module.exports = __webpack_public_path__ + "img/profile_teo_kk1.1ef13465.jpg";